import BaseDialog, { customStyles as defaultStyle } from 'components/dialog'
import ButtonBase from 'components/partials/button'
import React from 'react'

interface Props {
  title: string
  isOpenDialog: boolean
  handleCloseBtn: () => void
  handleConfirmBtn: () => void
  dialogStyle?: ReactModal.Styles['content']
}

const ConfirmDeleteDialog: React.FC<Props> = ({
  title,
  isOpenDialog,
  dialogStyle,
  handleCloseBtn,
  handleConfirmBtn,
}) => {
  const customDialogStyle = { content: { ...defaultStyle.content, ...dialogStyle } }
  return (
    <BaseDialog modalIsOpen={isOpenDialog} customStyles={customDialogStyle}>
      <div className="flex flex-col ">
        <div className="flex justify-center pb-5">
          <p className="text-headline5A text-neutral-1">{title}</p>
        </div>
        <div className="flex justify-between pt-5">
          <ButtonBase onClick={handleConfirmBtn}>Confirm</ButtonBase>
          <ButtonBase onClick={handleCloseBtn}>Close</ButtonBase>
        </div>
      </div>
    </BaseDialog>
  )
}

export default ConfirmDeleteDialog
